import { Home, Building2, Briefcase, Package, Zap } from "lucide-react";

const services = [
  { icon: Home, title: "Home Moves", desc: "Full house removals with care and efficiency. We handle everything so you don't have to." },
  { icon: Building2, title: "Apartment Moves", desc: "Need to move today? Call us, we'll make it happen." },
  { icon: Briefcase, title: "Office Relocations", desc: "Minimal downtime, maximum organisation. Your business keeps running." },
  { icon: Package, title: "Single Item Moves", desc: "Got one heavy piece? We'll pick it up and deliver it safely." },
  { icon: Zap, title: "Urgent / Same Day", desc: "Need to move today? Call us - we'll make it happen." },
];

const ServicesSection = () => (
  <section id="services" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        Our Moving Services
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Whatever you need moved, we've got you covered.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s) => (
          <div
            key={s.title}
            className="bg-card rounded-xl p-7 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-dark" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
